/* TenantWelcomeCard — bigger, glossier welcome card rendered at the
   TOP of the UniBuy™ sidebar (above the Instant RFQ banner). Lets the
   customer feel "this catalog has been curated for me" the moment they
   land in the storefront.

   For tenants with a true logo (Danone): renders the logo on a white
   card with a colored accent bar.
   For tenants with a photo asset (JDE Peet's): renders the photo as the
   card's left thumbnail with overlay text on the right.
*/
import React from "react";
import { Sparkles } from "lucide-react";

export default function TenantWelcomeCard({ brand }) {
  if (!brand) return null;

  if (brand.logo_kind === "image") {
    return (
      <div
        data-testid="tenant-welcome-card"
        className="rounded-xl p-4 bg-white border shadow-sm relative overflow-hidden"
        style={{ borderColor: brand.accent_border }}
      >
        <div
          aria-hidden
          className="absolute top-0 left-0 right-0 h-1"
          style={{ background: brand.accent }}
        />
        <div className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.22em] font-bold" style={{ color: brand.accent }}>
          <Sparkles size={11} /> Curated experience
        </div>
        <div className="mt-3 flex items-center justify-center bg-white py-2">
          <img
            src={brand.logo_url}
            alt={brand.name}
            className="h-14 w-auto object-contain"
            data-testid="tenant-welcome-logo"
          />
        </div>
        <div className="mt-3 text-[13px] font-display font-semibold text-slate-900 leading-tight text-center">
          Welcome, {brand.name}.
        </div>
        <div className="mt-1 text-[11px] text-slate-600 leading-relaxed text-center italic">
          {brand.tagline}
        </div>
        <div className="mt-3 text-[10px] uppercase tracking-[0.20em] font-bold text-slate-400 text-center">
          UniBuy™ × Infosys BPM
        </div>
      </div>
    );
  }

  // Photo treatment — square thumbnail left, text right
  return (
    <div
      data-testid="tenant-welcome-card"
      className="rounded-xl p-3 bg-white border shadow-sm relative overflow-hidden"
      style={{ borderColor: brand.accent_border }}
    >
      <div
        aria-hidden
        className="absolute top-0 left-0 right-0 h-1"
        style={{ background: brand.accent }}
      />
      <div className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.22em] font-bold mb-2" style={{ color: brand.accent }}>
        <Sparkles size={11} /> Curated experience
      </div>
      <div className="flex items-center gap-3">
        <div
          className="h-16 w-16 rounded-lg overflow-hidden shrink-0 border"
          style={{ borderColor: brand.accent_border }}
        >
          <img
            src={brand.logo_url}
            alt={brand.name}
            className="h-full w-full object-cover"
            data-testid="tenant-welcome-photo"
          />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[13px] font-display font-semibold text-slate-900 leading-tight">
            Welcome, {brand.name}.
          </div>
          <div className="mt-0.5 text-[11px] text-slate-600 leading-snug italic line-clamp-2">
            {brand.tagline}
          </div>
        </div>
      </div>
      <div className="mt-2.5 text-[10px] uppercase tracking-[0.20em] font-bold text-slate-400">
        UniBuy™ × Infosys BPM
      </div>
    </div>
  );
}
